import styled from '@emotion/styled';
import { Button, Colors, typographyStyle, Flex, CDS_ZINDEX } from '@revenuemarket/cds';
import { Typography } from 'antd';
import Image from 'next/image';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';
import { mixpanel } from '~pages/_app';

const FloatingWrapper = styled.div`
  position: fixed;
  width: 544px;
  height: 152px;
  bottom: 12px;
  border-radius: 36px;
  background: linear-gradient(
    86deg,
    rgba(250, 138, 0, 0.2) 0.18%,
    rgba(8, 177, 169, 0.2) 50%,
    rgba(27, 141, 251, 0.2) 99.82%
  );
  margin-left: -12px;
  backdrop-filter: blur(6px);
  padding: 4px;
  box-sizing: border-box;
  z-index: 1000;
`;

const ConsultReservationFloatingSection = () => {
  return (
    <FloatingWrapper>
      <Flex
        gap={24}
        style={{
          backgroundColor: Colors.white,
          borderRadius: 32,
          padding: 24,
          position: 'absolute',
          zIndex: CDS_ZINDEX.FLOATING_BUTTON,
          width: 536,
          height: 144,
        }}
        align="center"
      >
        <Image
          src="https://static.clobe.ai/image/simon-profile-for-consult.png"
          width={80}
          height={80}
          style={{
            width: 80,
            height: 80,
          }}
          alt="simon-profile"
        />
        <Flex direction="column" gap={8} style={{ flex: 1 }}>
          <Typography.Text
            style={{
              ...typographyStyle['16_500'],
            }}
          >
            클로브 금융이 궁금하신가요?
            <br />
            양시윤 담당자에게 직접 안내받아보세요.
          </Typography.Text>
          <Button
            buttonSize="xlarge"
            style={{
              width: '100%',
            }}
            buttonType="primary"
            onClick={() => {
              mixpanel.track(MIXPANEL_EVENT.HOME.CLICK_CONSULT_RESERVATION);
              window.open('https://whattime.co.kr/clobe-simon/financing-qna', '_blank');
            }}
          >
            담당자와 대화하기
          </Button>
        </Flex>
      </Flex>
    </FloatingWrapper>
  );
};

export default ConsultReservationFloatingSection;
